import { Button, message, Modal } from 'antd';
import { FC, useState } from 'react';
import styled from 'styled-components';
import baseuri from '../../methods/baseuri';

const DeleteSection = styled.div`
	display: inline-flex;
	margin-left: 10px;
`;
interface IReset2fa {
	// eslint-disable-next-line react/require-default-props
	details?: any | null;
	// eslint-disable-next-line react/require-default-props
	id?: string | null;
	requestId: string;
}
const Reset2fa: FC<IReset2fa> = ({ details, id, requestId }) => {
	const [loading, setLoading] = useState(false);
	const reset2fa = async () => {
		try {
			setLoading(true);
			const res = await baseuri.put(`admin/users/deactivate-two-factor`, {
				userId: details?.profile?._id || details?.userId?._id || id,
				requestId,
				status: 'processed',
			});
			if (res.status === 200) {
				setLoading(false);
				message.success(res.data.message);
			} else {
				message.info(res.data.message);
				setLoading(false);
			}
		} catch (e: any) {
			setLoading(false);
			message.error(e.response.data.message);
		}
	};
	const confirm = () => {
		Modal.confirm({
			title: 'Are you sure you want to Reset this user 2fa?',
			onOk() {
				reset2fa();
			},
		});
	};
	return (
		<DeleteSection>
			<Button
				loading={loading}
				type="primary"
				onClick={confirm}
				disabled={!!details?.profile?.enabledTwoFactor}
			>
				Deactivate 2fa
			</Button>
		</DeleteSection>
	);
};

export default Reset2fa;
